import {i18n} from '@netx/core-next/locales/i18n-instance';
import CMSActionCollection from '@netx/core-cms/collections/CMSActions';

export const currentPortalActions = new CMSActionCollection([], {
	comparator: (item: any) => i18n.t(item.get('label')).toLowerCase(),
});
